var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcotrade(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 479.81 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 73.62,
    y1: 69.34,
    x2: 345.73,
    y2: 503.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eace9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#bb8231"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -15.49,
    y1: 125.21,
    x2: 256.62,
    y2: 559.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 134.38,
    y1: 31.25,
    x2: 406.48,
    y2: 465.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 943.08,
    y1: 165.88,
    x2: 1215.19,
    y2: 599.88,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M752.51,820.36V779.47h31.42v7.36H761v9.35h15.13v7.07H761V813h23.19v7.36Z",
    transform: "translate(-719.66 -190.46)",
    style: {
      fill: "#2c2311"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.33,820.36l15.59-21.14-14.83-19.75h10.16l9.7,13.44,9.69-13.44h9.7L811.8,799.22l15.77,21.14H817.46l-10.69-14.83-10.69,14.83Z",
    transform: "translate(-719.66 -190.46)",
    style: {
      fill: "#2c2311"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.48,821a22.56,22.56,0,0,1-8.53-1.61,21.25,21.25,0,0,1-6.92-4.47,20.58,20.58,0,0,1-4.61-6.69,21.29,21.29,0,0,1,0-16.53,20.55,20.55,0,0,1,4.64-6.71,21.32,21.32,0,0,1,6.92-4.5,22.33,22.33,0,0,1,8.5-1.61,22.63,22.63,0,0,1,6.54.94,24.07,24.07,0,0,1,5.87,2.62,18.69,18.69,0,0,1,4.65,4.09l-5.73,5.61a14.06,14.06,0,0,0-5.08-4.12,14.59,14.59,0,0,0-6.25-1.37,13,13,0,0,0-5.14,1,12.77,12.77,0,0,0-6.89,7,13.63,13.63,0,0,0-1,5.32,13.16,13.16,0,0,0,3.83,9.43,12.83,12.83,0,0,0,4.2,2.78,14,14,0,0,0,5.35,1,13.71,13.71,0,0,0,6-1.35,14.46,14.46,0,0,0,4.9-3.85l5.49,5.49a19.31,19.31,0,0,1-4.58,4,22,22,0,0,1-5.81,2.6A23.18,23.18,0,0,1,848.48,821Z",
    transform: "translate(-719.66 -190.46)",
    style: {
      fill: "#2c2311"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.48,821a22.36,22.36,0,0,1-8.5-1.6,21.08,21.08,0,0,1-11.5-11.22,21.29,21.29,0,0,1,0-16.53,20.93,20.93,0,0,1,4.61-6.71,21.19,21.19,0,0,1,6.89-4.5,22.37,22.37,0,0,1,8.5-1.61,22.13,22.13,0,0,1,8.44,1.61,21.13,21.13,0,0,1,6.9,4.5,21,21,0,0,1,0,30,21.13,21.13,0,0,1-6.9,4.5A22.13,22.13,0,0,1,889.48,821Zm0-7.76a12.37,12.37,0,0,0,5.08-1,12.55,12.55,0,0,0,4.09-2.83,13.26,13.26,0,0,0,2.75-4.23,14.47,14.47,0,0,0,0-10.52,13.22,13.22,0,0,0-2.75-4.17,12.58,12.58,0,0,0-4.09-2.84,12.38,12.38,0,0,0-5-1,12.93,12.93,0,0,0-5.17,1,12.71,12.71,0,0,0-4.12,2.84,13.16,13.16,0,0,0-3.73,9.34,14,14,0,0,0,1,5.35,13.41,13.41,0,0,0,2.74,4.23,12.76,12.76,0,0,0,9.23,3.86Z",
    transform: "translate(-719.66 -190.46)",
    style: {
      fill: "#2c2311"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.71,821a22.13,22.13,0,0,1-8.47-1.6,21.87,21.87,0,0,1-6.92-4.5,20.25,20.25,0,0,1-4.64-6.72,20.78,20.78,0,0,1-1.64-8.26,20.51,20.51,0,0,1,1.67-8.27,21.17,21.17,0,0,1,4.58-6.71,20.87,20.87,0,0,1,6.84-4.5,22.05,22.05,0,0,1,8.46-1.61,23.17,23.17,0,0,1,9.56,2,19.63,19.63,0,0,1,7.44,5.63l-5.9,5.43a14,14,0,0,0-4.93-4,14.28,14.28,0,0,0-6.17-1.34,12.45,12.45,0,0,0-5.1,1,13,13,0,0,0-4.07,2.81,12.62,12.62,0,0,0-2.71,4.17,14.19,14.19,0,0,0-1,5.32,14,14,0,0,0,1,5.31,12.52,12.52,0,0,0,2.77,4.24,13.11,13.11,0,0,0,9.38,3.82,12,12,0,0,0,5.2-1.11,11.56,11.56,0,0,0,3.94-3,10.08,10.08,0,0,0,2.13-4.38H948.07v-7.36h21.15V800a22.2,22.2,0,0,1-1.55,8.38,20.69,20.69,0,0,1-4.3,6.66,19.41,19.41,0,0,1-6.48,4.41A20.85,20.85,0,0,1,948.71,821Z",
    transform: "translate(-719.66 -190.46)",
    style: {
      fill: "#2c2311"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975,820.36V779.47h8.47v33.42h22.37v7.47Z",
    transform: "translate(-719.66 -190.46)",
    style: {
      fill: "#2c2311"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.79,821a22.36,22.36,0,0,1-8.5-1.6,21.08,21.08,0,0,1-11.5-11.22,21.29,21.29,0,0,1,0-16.53,21.11,21.11,0,0,1,11.5-11.21,22.37,22.37,0,0,1,8.5-1.61,22.13,22.13,0,0,1,8.44,1.61,21.13,21.13,0,0,1,6.9,4.5,21,21,0,0,1,0,30,21.13,21.13,0,0,1-6.9,4.5A22.13,22.13,0,0,1,1028.79,821Zm0-7.76a12.45,12.45,0,0,0,5.09-1,12.62,12.62,0,0,0,4.08-2.83,13.26,13.26,0,0,0,2.75-4.23,14.47,14.47,0,0,0,0-10.52,13.22,13.22,0,0,0-2.75-4.17,12.65,12.65,0,0,0-4.08-2.84,12.46,12.46,0,0,0-5-1,12.93,12.93,0,0,0-5.17,1,12.6,12.6,0,0,0-4.12,2.84,13.16,13.16,0,0,0-3.73,9.34,14,14,0,0,0,1,5.35,13.41,13.41,0,0,0,2.74,4.23,12.76,12.76,0,0,0,9.23,3.86Z",
    transform: "translate(-719.66 -190.46)",
    style: {
      fill: "#2c2311"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.19,820.36V779.47h19.22a17.51,17.51,0,0,1,7.24,1.4,11.54,11.54,0,0,1,4.85,4,10.06,10.06,0,0,1,1.75,5.87,9.28,9.28,0,0,1-1.34,4.93,11.45,11.45,0,0,1-3.8,3.71,11.4,11.4,0,0,1,4.82,3.71,9,9,0,0,1,1.78,5.46,10.74,10.74,0,0,1-1.81,6.22,12,12,0,0,1-5,4.15,17.55,17.55,0,0,1-7.48,1.49Zm8.47-24.12h10.22a6.42,6.42,0,0,0,4.32-1.35,4.44,4.44,0,0,0,1.58-3.56,4.35,4.35,0,0,0-1.58-3.53,6.52,6.52,0,0,0-4.32-1.32h-10.22Zm0,17.11h11a7.11,7.11,0,0,0,4.7-1.43,4.71,4.71,0,0,0,1.72-3.82,4.8,4.8,0,0,0-1.72-3.86,7.07,7.07,0,0,0-4.7-1.46h-11Z",
    transform: "translate(-719.66 -190.46)",
    style: {
      fill: "#2c2311"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.82,820.36l16.82-40.89h9.81L1135,820.36h-9.17l-4.14-10.69h-16.94l-4.15,10.69Zm15.59-17.52h11.75l-5.79-15.07Z",
    transform: "translate(-719.66 -190.46)",
    style: {
      fill: "#2c2311"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.49,820.36V779.47H1147v33.42h22.37v7.47Z",
    transform: "translate(-719.66 -190.46)",
    style: {
      fill: "#2c2311"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.42,890.46V849.57h8.47V883h22.37v7.48Z",
    transform: "translate(-719.66 -190.46)",
    style: {
      fill: "#2c2311"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.1,890.46V849.57h8.47v40.89Z",
    transform: "translate(-719.66 -190.46)",
    style: {
      fill: "#2c2311"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897,890.46V849.57h10.92l11.16,22.08,11.21-22.08h10.81v40.89h-7.94V860.37L919,887.54l-14.13-27.28v30.2Z",
    transform: "translate(-719.66 -190.46)",
    style: {
      fill: "#2c2311"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.51,890.46V849.57H957v40.89Z",
    transform: "translate(-719.66 -190.46)",
    style: {
      fill: "#2c2311"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.55,890.46V857H961.77v-7.47h36V857H984v33.42Z",
    transform: "translate(-719.66 -190.46)",
    style: {
      fill: "#2c2311"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.48,890.46V849.57h31.42v7.36h-23v9.34h15.13v7.07H1011v9.76h23.19v7.36Z",
    transform: "translate(-719.66 -190.46)",
    style: {
      fill: "#2c2311"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.15,890.46V849.57h15.72a22.58,22.58,0,0,1,8.52,1.57,21.67,21.67,0,0,1,6.84,4.36,20.21,20.21,0,0,1,4.58,6.51,19.84,19.84,0,0,1-4.55,22.55,22.12,22.12,0,0,1-6.87,4.32,22.58,22.58,0,0,1-8.52,1.58Zm8.47-7.54h7.13a13,13,0,0,0,9.26-3.74,12.24,12.24,0,0,0,2.74-4.06,13,13,0,0,0,1-5,13.32,13.32,0,0,0-1-5.05,12.51,12.51,0,0,0-2.74-4.15,13,13,0,0,0-9.2-3.77h-7.19Z",
    transform: "translate(-719.66 -190.46)",
    style: {
      fill: "#2c2311"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.3 510.53 191.3 298.08 177.86 290.22 164.42 298.07 164.42 494.8 124.1 471.2 124.1 275.35 138.26 267.06 124.1 258.78 124.1 62.88 164.42 39.3 164.42 236.05 177.86 243.91 191.3 236.05 191.3 23.58 231.62 0 231.62 258.78 217.45 267.06 231.62 275.35 231.62 534.13 191.3 510.53",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 403.45 0 275.43 14.17 267.14 0 258.86 0 130.79 107.52 67.86 107.52 114.18 40.32 153.5 40.32 236.13 53.76 243.99 107.52 212.55 107.52 258.86 93.35 267.14 107.52 275.43 107.52 321.73 53.76 290.29 40.32 298.15 40.32 380.75 107.52 420.03 107.52 466.43 0 403.45",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.71 189.19 355.71 62.93 248.19 0 248.19 258.86 262.36 267.14 248.19 275.43 248.19 534.13 355.71 471.25 355.71 344.97 315.39 368.55 315.39 448.53 288.51 464.25 288.51 69.91 315.39 85.65 315.39 165.61 355.71 189.19",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.47,321.25,1092,258.31v191l14.17,8.29L1092,465.88v191l107.52-63v-128l-14.17-8.28,14.17-8.29Zm-40.32,250L1132.27,587V328.23L1159.15,344Z",
    transform: "translate(-719.66 -190.46)",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcotrade);
export default __webpack_public_path__ + "static/media/excotrade.2b4f9a35649ad87561988833d780d71b.svg";
export { ForwardRef as ReactComponent };